import React, { useEffect } from 'react'
import { Form, Input, Modal, message } from 'antd'
import { patchReq } from '../../../utils/request'

export interface IUserWithoutPhone {
	id: number
	firstName: string
	lastName: string
	phone: string | null
	organizationId: number | null
	organizationName: string | null
}

type Props = {
	user: IUserWithoutPhone | null
	onClose: () => void
	onSaved: () => void
}

const EditUserPhoneModal = ({ user, onClose, onSaved }: Props) => {
	const [form] = Form.useForm()
	const [submitting, setSubmitting] = React.useState(false)

	useEffect(() => {
		if (user) {
			form.setFieldsValue({
				firstName: user.firstName,
				lastName: user.lastName,
				phone: user.phone || ''
			})
		}
	}, [user, form])

	const handleOk = async () => {
		if (!user) return
		try {
			const values = await form.validateFields()
			setSubmitting(true)
			await patchReq(`/api/admin/users/${user.id}` as any, null, {
				firstName: values.firstName,
				lastName: values.lastName,
				phone: values.phone
			})
			message.success('Údaje zákazníka boli uložené')
			onSaved()
			onClose()
		} catch (err: any) {
			if (err?.errorFields) return // form validation error
			message.error('Nepodarilo sa uložiť zmeny')
		} finally {
			setSubmitting(false)
		}
	}

	return (
		<Modal
			title="Upraviť údaje zákazníka"
			visible={!!user}
			onOk={handleOk}
			onCancel={onClose}
			confirmLoading={submitting}
			okText="Uložiť"
			cancelText="Zrušiť"
			destroyOnClose
		>
			<Form form={form} layout="vertical">
				<Form.Item name="firstName" label="Meno" rules={[{ required: true, min: 2, max: 20 }]}>
					<Input />
				</Form.Item>
				<Form.Item name="lastName" label="Priezvisko" rules={[{ required: true, min: 2, max: 20 }]}>
					<Input />
				</Form.Item>
				<Form.Item
					name="phone"
					label="Telefónne číslo"
					rules={[
						{ required: true, message: 'Telefónne číslo je povinné' },
						{ pattern: /^\+[0-9]{12}$/, message: 'Formát: +421888666555 (13 znakov)' }
					]}
				>
					<Input placeholder="+421888666555" />
				</Form.Item>
			</Form>
		</Modal>
	)
}

export default EditUserPhoneModal
